import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["stroke"]
const _hoisted_8 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'SmileyCheck',
  props: {
  width: {
    type: [String, Number],
    default: 89,
  },
  height: {
    type: [String, Number],
    default: 98,
  },
  fill: {
    type: String,
    default: 'var(--ch-blue-100)',
  },
  stroke: {
    type: String,
    default: 'var(--ch-blue-100)',
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps(_ctx.$attrs, {
    width: __props.width,
    height: __props.width,
    viewBox: "0 0 89 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), [
    _createElementVNode("circle", {
      cx: "42.5",
      cy: "55.5",
      r: "42.5",
      fill: __props.fill,
      "fill-opacity": "0.34"
    }, null, 8, _hoisted_2),
    _createElementVNode("circle", {
      cx: "42.5",
      cy: "55.5",
      r: "31",
      stroke: __props.stroke
    }, null, 8, _hoisted_3),
    _createElementVNode("circle", {
      cx: "19",
      cy: "19",
      r: "6",
      fill: __props.fill
    }, null, 8, _hoisted_4),
    _createElementVNode("circle", {
      cx: "8.5",
      cy: "28.5",
      r: "4.25",
      stroke: __props.stroke,
      "stroke-width": "0.5"
    }, null, 8, _hoisted_5),
    _createElementVNode("circle", {
      cx: "34.5",
      cy: "2.5",
      r: "2.25",
      stroke: __props.stroke,
      "stroke-width": "0.5"
    }, null, 8, _hoisted_6),
    _createElementVNode("circle", {
      cx: "87",
      cy: "33",
      r: "1.75",
      stroke: __props.stroke,
      "stroke-width": "0.5"
    }, null, 8, _hoisted_7),
    _cache[0] || (_cache[0] = _createElementVNode("circle", {
      cx: "83.5",
      cy: "46.5",
      r: "2.25",
      stroke: "black",
      "stroke-opacity": "0.53",
      "stroke-width": "0.5"
    }, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("circle", {
      cx: "48.5",
      cy: "9.5",
      r: "2.25",
      stroke: "black",
      "stroke-opacity": "0.53",
      "stroke-width": "0.5"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("circle", {
      cx: "25.5",
      cy: "8.5",
      r: "1.5",
      fill: "black",
      "fill-opacity": "0.65"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("circle", {
      cx: "81.5",
      cy: "18.5",
      r: "1.5",
      fill: "black",
      "fill-opacity": "0.65"
    }, null, -1)),
    _createElementVNode("path", {
      d: "M71.6777 23.2988C71.5684 23.2533 71.4567 23.251 71.3428 23.292C71.2288 23.333 71.1491 23.4082 71.1035 23.5176L71.042 23.6406L70.8711 23.9141L70.5703 24.3105L70.1328 24.7275L69.5586 25.1172L68.8408 25.3975L67.9727 25.5137C67.9635 25.5137 67.9544 25.516 67.9453 25.5205L67.9316 25.5273C67.6764 25.5273 67.4303 25.5 67.1934 25.4453C66.9564 25.3906 66.7467 25.3154 66.5645 25.2197C66.3822 25.124 66.2113 25.0215 66.0518 24.9121C65.8923 24.8027 65.751 24.682 65.6279 24.5498C65.5049 24.4176 65.3978 24.2969 65.3066 24.1875C65.2155 24.0781 65.138 23.9688 65.0742 23.8594C65.0104 23.75 64.9648 23.6725 64.9375 23.627C64.9102 23.5814 64.8919 23.5449 64.8828 23.5176C64.8281 23.4082 64.7461 23.333 64.6367 23.292C64.5273 23.251 64.4157 23.2555 64.3018 23.3057C64.1878 23.3558 64.1104 23.4355 64.0693 23.5449C64.0283 23.6543 64.0352 23.7682 64.0898 23.8867C64.099 23.9141 64.1149 23.9505 64.1377 23.9961C64.1605 24.0417 64.2083 24.1214 64.2812 24.2354C64.3542 24.3493 64.4294 24.4632 64.5068 24.5771C64.5843 24.6911 64.6891 24.821 64.8213 24.9668C64.9535 25.1126 65.0924 25.2493 65.2383 25.377C65.3841 25.5046 65.555 25.6322 65.751 25.7598C65.9469 25.8874 66.152 25.9967 66.3662 26.0879C66.5804 26.179 66.8219 26.2542 67.0908 26.3135C67.3597 26.3727 67.6354 26.4023 67.918 26.4023C67.9271 26.4023 67.9453 26.3978 67.9727 26.3887C68.4922 26.3887 68.9844 26.2998 69.4492 26.1221C69.9141 25.9443 70.2832 25.7484 70.5566 25.5342C70.8301 25.32 71.0785 25.0716 71.3018 24.7891C71.5251 24.5065 71.6709 24.3037 71.7393 24.1807C71.8076 24.0576 71.86 23.9551 71.8965 23.873C71.9238 23.8366 71.9398 23.7933 71.9443 23.7432C71.9489 23.693 71.9443 23.6475 71.9307 23.6064C71.917 23.5654 71.901 23.5244 71.8828 23.4834C71.8646 23.4424 71.8372 23.4059 71.8008 23.374C71.7643 23.3421 71.7233 23.3171 71.6777 23.2988ZM68 15C67.0521 15 66.1452 15.1846 65.2793 15.5537C64.4134 15.9229 63.6683 16.4196 63.0439 17.0439C62.4196 17.6683 61.9229 18.4134 61.5537 19.2793C61.1846 20.1452 61 21.0521 61 22C61 22.9479 61.1846 23.8548 61.5537 24.7207C61.9229 25.5866 62.4196 26.3317 63.0439 26.9561C63.6683 27.5804 64.4134 28.0771 65.2793 28.4463C66.1452 28.8154 67.0521 29 68 29C68.9479 29 69.8548 28.8154 70.7207 28.4463C71.5866 28.0771 72.3317 27.5804 72.9561 26.9561C73.5804 26.3317 74.0771 25.5866 74.4463 24.7207C74.8154 23.8548 75 22.9479 75 22C75 21.0521 74.8154 20.1452 74.4463 19.2793C74.0771 18.4134 73.5804 17.6683 72.9561 17.0439C72.3317 16.4196 71.5866 15.9229 70.7207 15.5537C69.8548 15.1846 68.9479 15 68 15ZM68 28.125C67.3346 28.125 66.6898 28.0225 66.0654 27.8174C65.4411 27.6123 64.8783 27.3206 64.377 26.9424C63.8757 26.5641 63.4359 26.1243 63.0576 25.623C62.6794 25.1217 62.3877 24.5589 62.1826 23.9346C61.9775 23.3102 61.875 22.6654 61.875 22C61.875 21.1706 62.0368 20.3776 62.3604 19.6211C62.6839 18.8646 63.1191 18.2129 63.666 17.666C64.2129 17.1191 64.8646 16.6839 65.6211 16.3604C66.3776 16.0368 67.1706 15.875 68 15.875C68.8294 15.875 69.6224 16.0368 70.3789 16.3604C71.1354 16.6839 71.7871 17.1191 72.334 17.666C72.8809 18.2129 73.3161 18.8646 73.6396 19.6211C73.9632 20.3776 74.125 21.1706 74.125 22C74.125 22.8294 73.9632 23.6224 73.6396 24.3789C73.3161 25.1354 72.8809 25.7871 72.334 26.334C71.7871 26.8809 71.1354 27.3161 70.3789 27.6396C69.6224 27.9632 68.8294 28.125 68 28.125ZM65.8125 21.5625C66.0495 21.5625 66.2523 21.4759 66.4209 21.3027C66.5895 21.1296 66.6738 20.9245 66.6738 20.6875C66.6738 20.5326 66.6351 20.3867 66.5576 20.25C66.4801 20.1133 66.3753 20.0062 66.2432 19.9287C66.111 19.8512 65.9674 19.8125 65.8125 19.8125C65.5664 19.8125 65.359 19.8991 65.1904 20.0723C65.0218 20.2454 64.9375 20.4505 64.9375 20.6875C64.9375 21.043 65.0924 21.3027 65.4023 21.4668C65.5391 21.5306 65.6758 21.5625 65.8125 21.5625ZM70.1875 21.5625C70.2513 21.5625 70.3151 21.5534 70.3789 21.5352C70.4427 21.5169 70.5042 21.4941 70.5635 21.4668C70.6227 21.4395 70.6774 21.4053 70.7275 21.3643C70.7777 21.3232 70.8232 21.2777 70.8643 21.2275C70.9053 21.1774 70.9395 21.125 70.9668 21.0703C70.9941 21.0156 71.0146 20.9541 71.0283 20.8857C71.042 20.8174 71.0488 20.7513 71.0488 20.6875C71.0488 20.4505 70.9645 20.2454 70.7959 20.0723C70.6273 19.8991 70.4222 19.8125 70.1807 19.8125C69.9391 19.8125 69.734 19.8991 69.5654 20.0723C69.3968 20.2454 69.3125 20.4505 69.3125 20.6875C69.3125 20.9245 69.3968 21.1296 69.5654 21.3027C69.734 21.4759 69.9414 21.5625 70.1875 21.5625Z",
      fill: __props.fill
    }, null, 8, _hoisted_8),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M59.586 47.7243C59.3962 47.4725 59.1586 47.2606 58.8868 47.1007C58.6151 46.9407 58.3145 46.8359 58.0022 46.7922C57.69 46.7484 57.3721 46.7667 57.0669 46.8458C56.7617 46.9249 56.475 47.0634 56.2233 47.2534L36.4864 62.1403L32.3954 54.1948C32.251 53.9145 32.0529 53.6653 31.8123 53.4615C31.5716 53.2578 31.2932 53.1034 30.993 53.0072C30.3865 52.813 29.7277 52.8677 29.1616 53.1592C28.5954 53.4507 28.1682 53.9551 27.974 54.5616C27.7798 55.168 27.8345 55.8268 28.126 56.393L33.4976 66.8251C33.4976 66.8251 33.6572 67.1097 33.7393 67.2188C33.9291 67.4707 34.1667 67.6828 34.4385 67.8428C34.7103 68.0028 35.011 68.1077 35.3234 68.1515C35.6357 68.1952 35.9537 68.177 36.259 68.0978C36.5643 68.0186 36.851 67.8801 37.1027 67.69L59.1151 51.0869C59.3668 50.8971 59.5787 50.6595 59.7387 50.3878C59.8986 50.116 60.0034 49.8154 60.0472 49.5032C60.0909 49.1909 60.0727 48.8731 59.9936 48.5678C59.9144 48.2626 59.7759 47.976 59.586 47.7243Z",
      fill: "white"
    }, null, -1))
  ], 16, _hoisted_1))
}
}

})